import React from 'react'
import { SVGIconProps } from '../types'
const SvgPriorityHigh12Px = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 12a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 8 12m1.333-9.333v8H6.667v-8z"
      />
    </g>
  </svg>
)
export default SvgPriorityHigh12Px
